// src/utils/ambassadorApi.js
//
// fetch helper for the ambassador field app's API (/api/ambassador,
// backend/routes/ambassador/index.ts). Errors carry the backend's code
// (err.message, e.g. PROSPECT_ALREADY_RESERVED) and its details
// (err.details, e.g. { max: 3 }) so pages can say what happened.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

async function call(method, path, token, body) {
  const r = await fetch(`${API_BASE_URL}/ambassador${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    const { error, ...details } = data;
    const err = new Error(error || `HTTP_${r.status}`);
    err.details = details;
    err.status = r.status;
    throw err;
  }
  return data;
}

export const ambassadorGet = (path, token) => call('GET', path, token);
export const ambassadorPost = (path, token, body = {}) => call('POST', path, token, body);
